import background from '../img/herobg.png'
import Button from './common/Button';
import Header from './common/Header';
import Title from './common/Title';
import HeroForm from '../booking/HeroForm';
const Hero = () => { 

  
  return <>
    <div className="herowrap bgimage position-relative skew" style={{ backgroundImage: `url(${background})` }} >
      <div className="overlay" ></div>
      <div className="herowrap skew-rev" >
        <Header />
        <div className='heroContent' >
          <div className='container' >
            <div className='row  align-items-center' >
              <div className='col-lg-6 bannerContent' >
                <Title 
                  titleclass="lg text-white text-center text-lg-start"
                  title={<>Train Like <br></br><strong>The</strong> CHAMP!</>}
                  des="Mayweather Boxing + Fitness Dallas offers an authentic experience for those who want to learn from Floyd’s techniques and training regimens, while getting in the best shape of their lives in a high-intensity group fitness setting. Get started by booking a FREE class!"
                  desclass='py-3 m-0 text-white text-center text-lg-start' />
                <Button tag="a" href="#booknow" text={"Book NOW!"} cls="btn btn-primary mt-4 mt-lg-3 m-lg-0 m-auto d-table" />
              </div>
              <div className='pt-5 pt-lg-0 mt-5 mt-lg-0 col-lg-6 ps-lg-4 ps-xl-3' >
                  <HeroForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}

export default Hero; 